import { push } from 'react-router-redux'
import { userIsLoggedInDataFetched, userNeedsToResetPassword } from './user'
import { fetchManifest } from './manifest'
import { fetchPoliciesIfNeeded } from './policies'
import { getUsers } from './users'
import { getUserData } from './user'
import { fetchTags } from './tags'
import { setDefaultMyQuestsFilters } from './myquests'
import { getDefaultRoute } from '../utils/routes'
import { fetchMockCourses } from './mockcourses'

export function fetchDataAndRedirectUser(user) {
  return async (dispatch, getState) => {
    const acceptedPoliciesCount = Object.keys(user.policies_acceptance).length
    const urlParams = new URLSearchParams(window.location.search)
    const redirect = urlParams.get('redirect')

    if (!user.require_password_change_on_next_login) {
      await Promise.all([
        // password change not required, no need to keep password
        sessionStorage.removeItem('password'),
        dispatch(fetchPoliciesIfNeeded()),
        dispatch(getUsers()),
        dispatch(getUserData()),
        dispatch(fetchManifest()),
        dispatch(fetchTags()),
        dispatch(fetchMockCourses()),
        dispatch(setDefaultMyQuestsFilters())
      ])
      if (acceptedPoliciesCount !== 0) {
        const state = getState()
        const route = getDefaultRoute(state.user.user.organization_roles)
        dispatch(userIsLoggedInDataFetched())
        dispatch(push(redirect || route))
      }
    } else {
      await dispatch(userNeedsToResetPassword(true))
      dispatch(push('/changepassword'))
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/combined.js